import * as React from "react"

const ArrowDown = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        fill="#707070"
        {...props}
        viewBox={'0 0 18 18'}
    >
        <path
            fill="inherit"
            stroke={'none'}
            d="M16.2 5.93 15 4.8l-6 5.977L3 4.8 1.8 5.93 9 13.2l7.2-7.27Z"
        />
    </svg>
)

export default ArrowDown
